<template>
  <!-- <div id="main-wrapper pt-0" class="show"> -->
  <div class="landing_page">
    <div class="homepage">
      <div class="container">
        <el-card class="box-card" style="margin-top: 20px; padding-top: 20px">
          <el-header style="text-align: center">
            <h1>Company information authentication</h1>
          </el-header>
          <div class="row">
            <div class="col-xl-12 col-lg-12" style="margin-top: 40px">
              <section>
                <el-steps
                  :active="activeStep"
                  align-center
                  finish-status="success"
                >
                  <el-step title="General"></el-step>
                  <el-step title="Representives"></el-step>
                  <el-step title="Beneficial Owners"></el-step>
                  <el-step title="Documentation"></el-step>
                  <el-step title="Banking Info"></el-step>
                  <el-step title="Questionnaire"></el-step>
                </el-steps>
              </section>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-12 col-lg-12"
              style="margin-left: 10%; margin-top: 40px"
            >
              <!-- <el-page-header content="Authentication"> </el-page-header> -->
              <el-form
                ref="elForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
                label-position="top"
              >
                <el-row>
                  <el-col :span="24">
                    <el-row>
                      <el-col :span="20">
                        <el-row>
                          <el-col :span="8">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Beneficiary Name"
                                  prop="s5_name"
                                  required
                                >
                                  <el-input
                                    v-model="formData.s5_name"
                                    placeholder="This must be the same as your name"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="8">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Bank Account Number or IBAN"
                                  prop="s5_iban"
                                  required
                                >
                                  <el-input
                                    v-model="formData.s5_iban"
                                    placeholder="Please enter bank IBAN"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="8">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Bank Country"
                                  prop="s5_country"
                                  required
                                >
                                  <el-select
                                    filterable
                                    v-model="formData.s5_country"
                                    placeholder="Please select a country"
                                    clearable
                                    :style="{ width: '100%' }"
                                  >
                                    <el-option
                                      v-for="(item, index) in countryOptions()"
                                      :key="index"
                                      :label="item.label"
                                      :value="item.value"
                                      :disabled="item.disabled"
                                    ></el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>

                      <el-col :span="20">
                        <el-row>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Bank name"
                                  prop="s5_bank_name"
                                  required
                                >
                                  <el-input
                                    v-model="formData.s5_bank_name"
                                    placeholder="Please enter the bank name"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Bank branch name"
                                  prop="s5_branch_name"
                                >
                                  <el-input
                                    v-model="formData.s5_branch_name"
                                    placeholder="Japan is required, ignored by other countries"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="20">
                        <el-row>
                          <el-form-item
                            label="Recipient Address"
                            prop="s5_rec_address"
                            required
                          >
                            <el-input
                              v-model="formData.s5_rec_address"
                              placeholder="please enter recipient address"
                              clearable
                              :style="{ width: '100%' }"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            label="Bank address"
                            prop="s5_bank_address"
                            required
                          >
                            <el-input
                              v-model="formData.s5_bank_address"
                              placeholder="please enter bank address"
                              clearable
                              :style="{ width: '100%' }"
                            ></el-input>
                          </el-form-item>
                        </el-row>
                      </el-col>

                      <el-col :span="20">
                        <el-row>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Bank SWIFT"
                                  prop="s5_bank_swift"
                                >
                                  <el-input
                                    v-model="formData.s5_bank_swift"
                                    placeholder="Users in the U.S. don't have to provide SWIFT"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="12">
                            <el-row>
                              <el-col :span="21">
                                <el-form-item
                                  label="Routing Number"
                                  prop="s5_routing_no"
                                >
                                  <el-input
                                    v-model="formData.s5_routing_no"
                                    placeholder="for U.S. domestic banks only"
                                    clearable
                                    :style="{ width: '100%' }"
                                  ></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-col :span="24">
                      <el-form-item
                        label="Proof of Bank Account"
                        label-width="0"
                        prop="s5_proof_file"
                        required
                      >
                        <p style="color: #999; margin-bottom: 20px">
                          Please upload a recent bank statement that includes
                          your name and address.
                        </p>
                        <FileUpload
                          emitaction="set_s5_proof_file_file"
                          :fileurl="formData.s5_proof_file"
                          v-on:emitaction="set_s5_proof_file_file"
                        ></FileUpload>
                      </el-form-item>
                    </el-col>
                  </el-col>
                </el-row>
                <!-- <el-row>
                  <el-col>
                    <el-form-item label="Proof of bank account number:">
                      <p>You have two options:</p>
                      <p>
                        1. Provide near 1 month bank statement (Bank State,
                        usually downloaded directly from online banking as a PDF
                        file). The statement contains the applicant's name,
                        address, and account number.
                      </p>
                      <p>
                        2. Provide clear screenshots of online banking. The
                        screenshot clearly shows the name of the bank, the name
                        of the account owner (which must match the applicant's
                        name), and the account number to prove the authenticity
                        and accuracy of the bank information.
                      </p>
                    </el-form-item> -->
                <!-- <el-form-item label="银行账号证明：">
                      <p>您有两个选择：</p>
                      <p>
                        1. 提供近
                        1个月银行对账单（BankStatement，通常可以直接从网上银行下载为PDF文件）。对账单中包含有申请人姓名、地址和账号。
                      </p>
                      <p>
                        2.提供网上银行清晰截屏。截屏中清晰显示银行名称，账户所有人名称（必须与申请人姓名一致），以及账号，以证明银行信息的真实性与准确性。
                      </p>
                    </el-form-item> -->
                <!-- </el-col>
                </el-row> -->

                <el-row :gutter="20" style="margin-top: 40px">
                  <!-- <el-col :span="6" :offset="0"
                    ><el-button @click="goback">Previous</el-button></el-col
                  > -->
                  <el-col :span="24" :offset="7">
                    <el-form-item size="large">
                      <el-button type="primary" @click="submitForm"
                        >Submit</el-button
                      >
                      <el-button @click="resetForm">Reset</el-button>
                    </el-form-item></el-col
                  >
                </el-row>
                <div class="row">
                  <div class="col-xl-2 col-lg-2" style="margin-top: 40px">
                    <el-form-item size="large"> </el-form-item>
                  </div>
                  <div class="col-xl-4 col-lg-4" style="margin-top: 40px"></div>
                </div>
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
import FileUpload from "../../components/plugins/FileUpload2.vue";
import {
  otc_auth_status,
  get_info,
  att_info,
} from "../../plugins/api/account_otc";
import { countryOptions } from "../../plugins/data/form_base_data";
export default {
  components: { FileUpload },
  props: [],
  data() {
    return {
      activeStep: 4,
      formData: {
        process: 5,
        passport: undefined,
        idfileType: "",
        idFile: "",
        selfie: "",
        addrProve: "",
      },
      rules: {
        s5_name: [
          {
            required: true,
            message: "please enter name.",
            trigger: "blur",
          },
        ],
        s5_iban: [
          {
            required: true,
            message: "Please enter bank IBAN.",
            trigger: "blur",
          },
        ],
        s5_country: [
          {
            required: true,
            message: "please select country.",
            trigger: "blur",
          },
        ],
        s5_proof_file: [
          {
            required: true,
            message:
              "Please upload a recent bank statement that includes your name and address.",
            trigger: "blur",
          },
        ],
        s5_bank_name: [
          {
            required: true,
            message: "please enter bank name",
            trigger: "change",
          },
        ],
        s5_rec_address: [
          {
            required: true,
            message: "please enter recipient address",
            trigger: "change",
          },
        ],
        s5_bank_address: [
          {
            required: true,
            message: "please enter bank address",
            trigger: "change",
          },
        ],
        s5_bank_swift: [
          {
            required: true,
            message: "Users in the U.S. don't have to provide SWIFT",
            trigger: "change",
          },
        ],
      },
      idFileAction: "https://jsonplaceholder.typicode.com/posts/",
      idFilefileList: [],
      selfieAction: "https://jsonplaceholder.typicode.com/posts/",
      selfiefileList: [],
      addrProveAction: "https://jsonplaceholder.typicode.com/posts/",
      addrProvefileList: [],
      idfileTypeOptions: [
        {
          label: "Passport",
          value: 1,
        },
        {
          label: "U.S. driver's license",
          value: 2,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    otc_auth_status().then((res) => {
      console.log(res);
      if (res && res.data) {
        // console.log("reg attach info complete!");
      }
    });

    get_info(
      `/account_otc/get_company_info?process=${this.formData.process}`
    ).then((res_query) => {
      if (res_query.data) {
        this.$Message.success("This information has been stored");
        this.formData = res_query.data;
      } else {
      }
    });
  },
  mounted() {},
  methods: {
    set_s5_proof_file_file(url) {
      this.formData.s5_proof_file = url;
    },
    countryOptions() {
      return countryOptions;
    },
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        this.formData.process = 5;
        att_info("/account_otc/att_company_info", this.formData).then((res) => {
          if (res.code == 0 || res.code == 18289475) {
            this.$router.push("/reg/inc_cert/step6");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
    idFileBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    selfieBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    addrProveBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    goback() {
      this.$router.push("/reg/inc_cert/step4");
    },
  },
};
</script>
<style>
.el-icon-plus:before {
  top: 70px;
  position: relative;
}
.el-upload__tip {
  line-height: 1.2;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>